































































































import { Vue, Component, Watch } from "vue-property-decorator";

import Notification from "@/components/icons/IconBell.vue";
import Popover from "@/components/common/Popover.vue";
import NotificationItem from "@/components/common/NotificationItem.vue";

import { notificationsModule } from "@/plugins/store-accessors";
import IconClose from "@/components/icons/IconClose.vue";

@Component({
  components: {
    IconClose,
    NotificationItem,
    Popover,
    Notification,
  },
})
export default class NotificationsButton extends Vue {
  opened = false;
  newCount = 0;
  timer: any;
  lastNotification: any = null;
  previewHeight = 0;

  @Watch("lastNotification", { immediate: true })
  onLastNotificationChange(newVal: any) {
    if (newVal) {
      this.$nextTick(() => {
        const preview = this.$refs.previewNotification as Vue;
        this.previewHeight = preview
          ? (preview.$el as HTMLElement).offsetHeight
          : 0;
      });
    } else {
      this.previewHeight = 0;
    }
  }

  get count() {
    return notificationsModule.getCount;
  }

  get getLastNotification() {
    return notificationsModule.getLastNotification;
  }
  get notifications() {
    return notificationsModule.getNotifications;
  }

  async toggleNotifications() {
    if (!this.opened) {
      await notificationsModule.requestNotifications();
      await notificationsModule.requestCount();
      this.newCount = 0;
      this.lastNotification = null;
    }
    this.opened = !this.opened;
  }

  onClickOutside(event: MouseEvent) {
    this.opened = this.$el.contains(event.target as Node) && this.opened;
  }

  onClosePreview() {
    this.lastNotification = null;
  }

  playNotification() {
    const audio = this.$refs.audioNotification as HTMLAudioElement;
    audio.play();
  }

  async notificationsMounted() {
    await notificationsModule.requestCount();
    this.newCount = this.count;
    this.lastNotification = this.getLastNotification;

    this.timer = setInterval(async () => {
      await notificationsModule.requestCount();
      if (this.newCount < this.count) {
        this.newCount = this.count;
        this.lastNotification = this.getLastNotification;
        this.playNotification();
      }
    }, 60000);
  }

  mounted() {
    document.addEventListener("click", this.onClickOutside);
    this.notificationsMounted();
  }

  beforeDestroy() {
    document.removeEventListener("click", this.onClickOutside);
    clearTimeout(this.timer);
  }
}
